import { Link } from 'react-router-dom';
import { getLatestUpdates } from '@/mocks/manga';

export default function LatestUpdates() {
  const latest = getLatestUpdates(6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">第一时间获取最新章节，不再错过任何精彩内容</p>
          </div>
          <Link
            to="/"
            className="text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400">{manga.category}</span>
                  {manga.updateStatus === '已完结' ? (
                    <span className="text-xs bg-secondary-200 text-secondary-700 px-2 py-0.5 rounded-full">已完结</span>
                  ) : (
                    <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full">连载中</span>
                  )}
                </div>
                <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2">
                  更新至 {manga.latestChapter} · {manga.updateTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}